/** Operations tracked by the backend AuditLogger. */
export type AuditOperation = 'create' | 'update' | 'delete';

export interface AuditLogChange {
    field: string;
    oldValue: any;
    newValue: any;
}

/** User that performed the operation, as stored on the log (name/role captured at that time). */
export interface AuditLogActor {
    id: string | null;
    name?: string;
    email?: string;
    role?: string;
}

export interface AuditLogRecord {
    id: string;
    /** Model / collection the change was made on, e.g. "SellInvoice". */
    collectionName: string;
    documentId: string | null;
    operation: AuditOperation;
    timestamp: string;
    user: AuditLogActor;
    changes?: AuditLogChange[];
    /** Only returned by the details endpoint (or when includeState is requested). */
    lastState?: any;
    createdAt?: string;
    updatedAt?: string;
}

export interface AuditLogPagination {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
}

export interface AuditLogListResult {
    data: AuditLogRecord[];
    pagination: AuditLogPagination;
}

/** Per-model counts, used to build the model filter options. */
export interface AuditLogSummaryItem {
    collectionName: string;
    total: number;
    create: number;
    update: number;
    delete: number;
    lastActivityAt: string | null;
}

export interface AuditLogQuery {
    /** One or more model names, e.g. ["SellInvoice", "Order"]. */
    collectionName?: string[];
    operation?: AuditOperation[];
    documentId?: string;
    userId?: string;
    from?: string;
    to?: string;
    page?: number;
    limit?: number;
    sort?: 'asc' | 'desc';
    includeState?: boolean;
}

export const AUDIT_OPERATIONS: AuditOperation[] = ['create', 'update', 'delete'];

export const emptyAuditPagination: AuditLogPagination = {
    total: 0,
    page: 1,
    limit: 25,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
};
